import { createFileRoute } from "@tanstack/react-router";
import { ExamDashboardPage } from "@/routes/_main/exams/$slug/index";

export const Route = createFileRoute("/_main/groups/$gid/exams/$slug/")({
  component: ExamDashboardPage,
});
